import { render, staticRenderFns } from "./CoursesDropdown.vue?vue&type=template&id=65988ec2&"
import script from "./CoursesDropdown.vue?vue&type=script&lang=ts&"
export * from "./CoursesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports